import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import {
  ProductVolumePricingModal,
  useProductVolumePricingContext,
} from '../../../product'
import { ProductHeadGenericLabel } from '../ProductHead/ProductHeadLabels/ProductHeadGenericLabel/ProductHeadGenericLabel'

import { useGenerateVolumePricingBadgeData } from './useGenerateVolumePricingBadgeData'

type ProductPageVolumePricingBadgeProps = {
  className?: string
}
export const ProductPageVolumePricingBadge: FC<
  ProductPageVolumePricingBadgeProps
> = ({ className }) => {
  const { discount, discountActivated, quantity } =
    useGenerateVolumePricingBadgeData()
  const { openableControls } = useProductVolumePricingContext()

  if (!discount || !quantity) {
    return null
  }

  return (
    <>
      <ProductVolumePricingModal />
      <ProductHeadGenericLabel
        className={clsx(
          'flex w-fit flex-nowrap items-center justify-center gap-1 rounded-full border-none bg-light-tertiary p-2 text-xs text-dark-primary-max',
          className,
        )}
        onClick={openableControls.handleOpen}
        type="button"
      >
        {discountActivated ? (
          <FormattedMessage
            id="volumePricing.pdp.label.maxDiscount.text"
            values={{
              discount,
            }}
          />
        ) : (
          <FormattedMessage
            id="volumePricing.pdp.label.text"
            values={{
              discount,
              quantity,
            }}
          />
        )}

        <IconInfo className="size-4" />
      </ProductHeadGenericLabel>
    </>
  )
}
